<mat-sidenav-container fullscreen [autosize]="containerAutosize">
  <mat-sidenav #sidenav
              class="td-layout-sidenav"
              [mode]="mode"
              [opened]="opened"
              [style.max-width]="sidenavWidth"
              [style.min-width]="sidenavWidth"
              [disableClose]="disableClose">
    <ng-content select="td-navigation-drawer"></ng-content>
    <ng-content select="[td-sidenav-content]"></ng-content>
  </mat-sidenav>
  <ng-content></ng-content>
</mat-sidenav-container>
